import { screenSizeIsConsideredDesktop, useScreenSize } from "@/lib/common/ScreenSizeContext";

export function useIsMobile() {
	return !screenSizeIsConsideredDesktop(useScreenSize());
}
